import React from 'react';
import {
  ArrayField,
  Datagrid,
  NumberField,
  ReferenceField,
  TextField,
  useRecordContext,
} from 'react-admin';
import { QuickbooksPriceField } from '../components/QuickbooksPriceField';
import { QuickbooksItemLine } from '../types';

export const QbLinesFields = () => {
  const record = useRecordContext();
  if (record && record.Line)
    record.Line = record.Line.filter((line: QuickbooksItemLine) => !!line.Id);

  return (
    <ArrayField source="Line">
      <Datagrid bulkActionButtons={false}>
        <ReferenceField
          source="SalesItemLineDetail.ItemRef.value"
          reference="items"
          label="Name"
        >
          <TextField source="Name" />
        </ReferenceField>

        <TextField source="Description" />

        <QuickbooksPriceField source="SalesItemLineDetail.UnitPrice" label="Unit Price"/>
        <NumberField source="SalesItemLineDetail.Qty" label="Quantity" />
        <QuickbooksPriceField source="Amount" />
        <ReferenceField
          source="SalesItemLineDetail.TaxCodeRef.value"
          reference="taxes"
          label="Tax Class"
          
        >
          <TextField source="Name" />
        </ReferenceField>
      </Datagrid>
    </ArrayField>
  );
};
